import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { Option } from '@shared/types/components.type';

import { AgControlComponent, AgControlComponentParams, noop } from './ag-control.component';

interface AgDropdownComponentParams extends AgControlComponentParams {
  bindLabel?: string;
  classes?: string;
  disableTooltip?: string;
  options: Option[];
  searchable?: boolean;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, NgSelectModule, TooltipDirective, AsyncPipe, NgClass],
  styleUrls: ['./ag-dropdown.component.scss'],
  template: `
    @if (formGroup$ | async) {
      <div [formGroup]="$any(formGroup$ | async)">
        @if (isReady$ | async) {
          <ng-select
            placeholder="Select"
            [multiple]="false"
            [appendTo]="'body'"
            [searchable]="!!params.searchable"
            [items]="params.options"
            [bindValue]="'value'"
            [bindLabel]="params.bindLabel || 'label'"
            [clearable]="true"
            [ngClass]="(hasError ? 'invalid ' : '') + params.classes + ' aux-ag-select'"
            [formControl]="formControl"
            [auxTooltip]="formControl.disabled ? params.disableTooltip || '' : ''"
            (change)="changeHandler($event)"
          >
            <ng-template let-item="item" ng-option-tmp>
              <div
                auxTooltip
                [template]="
                  optionTitle.offsetWidth < optionTitle.scrollWidth ||
                  optionSubtitle.offsetWidth < optionSubtitle.scrollWidth
                    ? tooltipTemplate
                    : undefined
                "
                class="pr-4 text-sm leading-5"
              >
                <p
                  class="truncate font-bold"
                  [ngClass]="{ 'font-bold': !!item.subTitle }"
                  #optionTitle
                >
                  {{ item.label || item.title }}
                </p>
                <p class="truncate italic" #optionSubtitle>
                  {{ item.subTitle }}
                </p>
              </div>

              <ng-template #tooltipTemplate>
                <div>
                  <p>{{ item.label || item.title }}</p>
                  <p>{{ item.subTitle }}</p>
                </div>
              </ng-template>
            </ng-template>
          </ng-select>
        }
      </div>
    }
  `,
})
export class AgDropdownComponent extends AgControlComponent {
  params!: AgDropdownComponentParams;

  agInit(params: AgDropdownComponentParams): void {
    this.params = params;
    this.value = params.value;
    this.fieldName = params.colDef?.field;
    this.changeHandler = params.changeHandler ?? noop;
    this.updateView(params);
  }
}
